/** Product branding — single source of truth for UI and transactional email footers. */
/** Primary contact inbox — mailto links, support, legal, and Reply-To for Resend mail. */
const CONTACT_EMAIL = 'hello@truetradepath.com';

/**
 * Resend-verified sending domain (SPF/DKIM). From addresses only — not shown as contact mailto.
 * DNS for mail.truetradepath.com is not set yet; record setup in docs/decisions.md before launch.
 */
export const RESEND_MAIL_DOMAIN = 'mail.truetradepath.com';

export const BRAND = {
  name: 'Contractor Growth Kit',
  /** Hero headline — outcome-focused for US trade business owners. */
  tagline: "See what's costing your website customers, and fix it this week, on the site you already have.",
  description:
    'Website check-up and growth toolkit for US trade businesses: find what is costing you customers on the site you already have, then fix it with practical kits — no rebuild required.',
  /** App host (landing, auth, kits). Standalone Contractor Growth Kit. */
  domain: 'app.truetradepath.com',
  /** General contact — legal, billing questions, support mailto links. */
  helloEmail: CONTACT_EMAIL,
  /** Primary inbox — support form destination and Reply-To for platform Resend mail. */
  supportEmail: CONTACT_EMAIL,
  supportEmailLabel: 'Contractor Growth Kit Support',
  privacyEmail: CONTACT_EMAIL,
  securityEmail: CONTACT_EMAIL,
  /** Reply-To when sending from @mail.truetradepath.com via Resend (verify, password reset, etc.). */
  replyToEmail: CONTACT_EMAIL,
  /** Default Resend From for account/transactional mail (must stay on verified mail. subdomain). */
  resendTransactionalFrom: `Contractor Growth Kit <hello@${RESEND_MAIL_DOMAIN}>`,
  /** Default Resend From for transactional / kit notifications (legacy renewal reminders when enabled). */
  resendRemindersFrom: `Contractor Growth Kit <notifications@${RESEND_MAIL_DOMAIN}>`,
  poweredBy: 'Powered by Contractor Growth Kit',
  copyright: `© ${new Date().getFullYear()} Contractor Growth Kit`,
} as const;
